import swal from 'sweetalert'

export const showAlert = (string) => swal(string, {buttons: { cancel: 'OK'}})